import client from '../../client'

const getAll = params => {
  return client.get(`api/v1/customers`, {
    params
  });
}

const update = (id, params) => {
  return client.put(`api/v1/customers/${id}`, params);
}

export {
  getAll,
  update
}



// WEBPACK FOOTER //
// ./src/store/api/customer.js